<template>
  <div ref="layout" class="page-container">
    <div class="query-title">发货订单查询</div>
    <div class="content table-query">
      <collapse-query2>
        <template slot="content">
          <div class="query-container">
            <el-form inline size="mini" label-width="100px" :model="conditions">
              <el-row :gutter="24">
                <el-col :lg="8" :md="12">
                  <el-form-item label="要货单号">
                    <el-input v-model="conditions.wantCode" type="text" clearable />
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="12">
                  <el-form-item label="发货仓库">
                    <el-select v-model="conditions.warehouse">
                      <el-option
                        v-for="item in selectDataOptions['Warehouse']"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="12">
                  <el-form-item label="发运单号">
                    <el-input v-model="conditions.logisticno" type="text" clearable />
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="12">
                  <el-form-item label="申请日期起">
                    <el-date-picker
                      v-model="conditions.startDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                    />
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="12">
                  <el-form-item label="申请日期止">
                    <el-date-picker
                      v-model="conditions.endDate"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期"
                    />
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="12">
                  <el-form-item label="客户编码">
                    <wly-input
                      v-model="conditions.customerCode"
                      input-type="customer"
                      @enter="handleEnter"
                      @handleSuffixClick="openDialog($event, '客户选择')"
                    />
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="12">
                  <el-form-item label="签收日期起">
                    <el-date-picker
                      v-model="conditions.signStartDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                    />
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="12">
                  <el-form-item label="签收日期止">
                    <el-date-picker
                      v-model="conditions.signEndDate"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期"
                    />
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="12">
                  <el-form-item label="产品编码">
                    <wly-input
                      v-model="conditions.productCode"
                      input-type="customer"
                      @enter="handleEnter"
                      @handleSuffixClick="openDialog($event, '产品选择')"
                    />
                  </el-form-item>
                </el-col>
                <!--el-col :lg="8" :md="12">
                  <el-form-item label="备注反馈情况">
                    <el-input v-model="conditions.remark" /-->
                    <!-- <el-select v-model="conditions.remark">
                      <el-option
                        v-for="item in selectDataOptions['remark']"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      />
                    </el-select> -->
                  <!--/el-form-item>
                </el-col-->
                <el-col :lg="8" :md="12">
                  <el-form-item label="有签收图片">
                    <el-select v-model="conditions.isSigned">
                      <el-option label="是" value="1" />
                      <el-option label="否" value="0" />
                    </el-select>
                    <!-- <el-checkbox v-model="conditions.checkOut" true-label="1" false-label="0">是</el-checkbox> -->
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="12">
                  <el-form-item label="是否已结算">
                    <el-select v-model="conditions.settlement">
                      <el-option label="是" value="1" />
                      <el-option label="否" value="0" />
                    </el-select>
                    <!-- <el-checkbox v-model="conditions.settlement" true-label="1" false-label="0">是</el-checkbox> -->
                  </el-form-item>
                </el-col>
                <el-col :lg="8" :md="12">
                  <el-form-item label="是否已对账">
                    <el-select v-model="conditions.checkOut">
                      <el-option label="是" value="1" />
                      <el-option label="否" value="0" />
                    </el-select>
                    <!-- <el-checkbox v-model="conditions.checkOut" true-label="1" false-label="0">是</el-checkbox> -->
                  </el-form-item>
                </el-col>
                </el-row>
                <el-button size="mini" icon="el-icon-search" type="primary" @click="queryData(1)">查询</el-button>
                <el-button size="mini" icon="el-icon-refresh-right" @click="reset">重置</el-button>
            </el-form>
          </div>
        </template>
      </collapse-query2>

      <div class="table-container">
        <Table-filter
          title="明细"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          :custome-config="() => vxeShowCustom('gridOptions')"
        >
          <template #button>
            <table-button name="export" tip="导出" @click="exportExcel('发货订单信息')" />
          </template>
          <vxe-grid
            ref="gridOptions"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="332"
            max-height="500"
            align="center"
            size="mini"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :span-method="mergeRowMethod"
          >
            <template #settlementNo="{row}">
              <span class="blue" @click="showDialog(row)">{{ row.settlementNo }}</span>
            </template>
            <template #originalDrawing="{row}">
              <a v-if="row.originalDrawing" class="blue" @click="showImages(row.originalDrawing)">查看</a>
              <span v-else />
            </template>
            <template #picture="{row}">
              <a v-if="row.picture" class="blue" @click="showImages(row.picture)">查看</a>
              <span v-else />
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>
    <el-image-viewer
      v-if="showViewer"
      :on-close="()=>{showViewer = false}"
      :url-list="viewers"
    />
    <!-- 选择通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="dialogTitle === '客户选择'">
        <client-select ref="ClientSelect" />
      </template>
      <template v-if="dialogTitle === '产品选择'">
        <product-select ref="ProductSelect" />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-check"
          @click="submitHandle"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiDeliveryorderquery,apiDeliveryorderqueryExcelExport } from '@/api/applyForGoods/logisticsAbnormal'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'
const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
const ProductSelect = () => import('@/components/dialog/ProductSelect.vue')

export default {
  components: { ElImageViewer, ClientSelect, ProductSelect },
  data() {
    return {
      showDialog: false,
      dialogTitle: '',
      showViewer: false,
      conditions: {
        checkOut: '',
        customerCode: '',
        endDate: '',
        signEndDate: '',
        productCode: '',
        settlement: '',
        startDate: '',
        signStartDate: '',
        wantCode: '',
        logisticno: ''
      },
      selectDataOptions: {},
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { title: '要货单号', field: 'wantCode', width: 100 },
          { title: '发运单号', field: 'logisticno', width: 120 },
          { title: '客户编码', field: 'customerCode', width: 100 },
          { title: '客户名称', field: 'customerName', width: 160 },
          { title: '产品名称', field: 'productDesc', width: 190 },
          { title: '申请数量(件)', field: 'wantQuantity', width: 90, xlsxFmt: { t: 'n' }},
          { title: '申请瓶数', field: 'wantQuantityDetail', width: 70, xlsxFmt: { t: 'n' }},
          { title: '发运数量(件)', field: 'actDeliveryQty', width: 90, xlsxFmt: { t: 'n' }},
          { title: '发货仓库', field: 'warehouse', width: 100 },
          // { title: '收货城市', field: 'receiveCityName', width: 100 },
          { title: '收货地址', field: 'receiveAddress', width: 180 },
          // { title: '运单号', field: 'logisticno', width: 120 },
          { title: '申请日期', field: 'createdDate', width: 135 },
          { title: '应到货时间', field: 'shouldArrivedate', width: 135 },
          { title: '安吉接收时间', field: 'anjiReceiveDate', width: 135 },
          { title: 'ERP接收时间', field: 'sendTime', width: 135 },
          { title: '发运状态', field: 'orderStatusTextView', width: 120 },
          { title: '发货时间', field: 'shipTime', width: 135 },
          { title: '到货时间', field: 'reachedTime', width: 135 },
          { title: '客户签收时间', field: 'signDate', width: 135 },
          // { title: '运单签收附件', field: 'remark1', width: 100 },
          // { title: '客户签收附件', field: 'originalDrawing', width: 100 },
          { title: '客户签收图片', field: 'originalDrawing', slots: { default: 'originalDrawing' }, width: 70 },
          { title: '安吉签收图片', field: 'picture', slots: { default: 'picture' }, width: 70 },
          { title: '备注', field: 'remark', width: '130' },
          { field: 'checkOut', title: '是否对账', width: 80, formatter: ({ cellValue }) => cellValue == 1 ? '是' : '否' },
          { field: 'settlement', title: '是否结算', width: 80, formatter: ({ cellValue }) => cellValue == 1 ? '是' : '否' }
        ],
        data: []
      }
    }
  },
  computed: {
  },
  created() {
    this.getSelectDictDataOrigin('Warehouse')
  },
  methods: {
    reset() {
      this.conditions = {
        checkOut: '',
        isSigned: '',
        warehouse: '',
        customerCode: '',
        endtDate: '',
        signEndDate: '',
        productCode: '',
        settlement: '',
        startDate: '',
        signStartDate: '',
        wantCode: ''
      }
    },
    showImages(pic) {
      this.showViewer = true
      this.viewers = pic.split(',')
    },
    async queryData(page) {
      page && (this.pagination.page = page)
      const params = {
        ...this.conditions,
        ...this.pagination
      }
      const { data: { Rows, Total }} = await apiDeliveryorderquery(params)
      this.gridOptions.data = Rows
      this.pagination.totalCount = Total
    },
    async exportExcel(fileName) {
      const params = {
        ...this.conditions
       // ...this.ranges
      }
      const res = await apiDeliveryorderqueryExcelExport(params)
      if (res?.status !== 1) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data
      }&authToken=${getToken()}&fileName=${fileName}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      // link.target = '_blank'
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    openDialog(e,title) {
      e.target.blur()
      this.showDialog = true
      this.dialogTitle = title
    },
    handleEnter(e, type, data, row) {
      if (typeof type === 'object') {
        this.$message.warning(type.message)
        return
      }
      if (!data) return
      switch (type) {
        case 'customer':
          this.conditions.customerCode = data.customerCode
          break
        case 'product':
          this.conditions.productCode = data.PRODUCT_ID
          break
      }
    },
    // 通用行合并函数（将相同多列数据合并为一行）
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      const fields = [
        'wantQuantity',
        'wantQuantityDetail',
        'customerName',
        'productDesc',
        'createdDate',
        'warehouse',
        'receiveAddress',
        'shouldArrivedate',
        'sendTime',
        'shipTime',
        'remark',
        'checkOut'
      ]
      const cellValue = row[column.property]
      if (column.property === 'wantCode') {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      } else if (fields.includes(column.property)) {
        let nextRow = visibleData[_rowIndex + 1]
        const prevRow = visibleData[_rowIndex - 1]
        if (prevRow && prevRow['wantCode'] === row['wantCode']) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow['wantCode'] === row['wantCode']) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return {
              rowspan: countRowspan,
              colspan: 1
            }
          }
        }
      }
    },
    async submitHandle() {
      if (this.dialogTitle === '客户选择') {
        const data = await this.$refs.ClientSelect.submitForm()
        // 客户选择
        this.conditions.customerCode = data.customerCode
      } else {
        // 产品选择
        const data = await this.$refs.ProductSelect.submitForm()
        this.conditions.productCode = data.PRODUCT_ID
      }
      this.showDialog = false
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/data-searching/deliveryOrderSearch.vue